import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsAbstract } from '../../abstract/widgets/widgets.abstract';

export class ValdnWidgetsTimeRangeModel extends WidgetsAbstract {
  readonly icon: string = 'fact_check';
  readonly name: string = 'timeRange';
  readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.VALDN_TIMERANGE;
  template: string = `{
  "name": "timeRange",
  "options": {
    "data": {
      "row1": {
        "timeRange1_from": "timeRange1_from",
        "timeRange1_to": "timeRange1_to",
        "Days1": "BusinessHoursDays_1"
      },
      "row2": {
        "timeRange2_from": "timeRange2_from",
        "timeRange2_to": "timeRange2_to",
        "Days2": "BusinessHoursDays_2"
      },
      "row3": {
        "timeRange3_from": "timeRange3_from",
        "timeRange3_to": "timeRange3_to",
        "Days3": "BusinessHoursDays_3"
      }
    },
    "errorPath": "timeRange1_from"
  }
}`;
  readonly badge: string = 'VT';
  readonly placeholderClassName: string = 'valdn-placeholder';
  type: string = 'valdn';

  cloneFrom(origin: WidgetsAbstract): WidgetsAbstract {
    return this;
  }
}
